
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12 1.875c5.531 0 10.125 4.547 10.125 10.125A10.113 10.113 0 0112 22.125c-5.625 0-10.125-4.5-10.125-10.125 0-5.578 4.5-10.125 10.125-10.125zm0-1.5C5.578.375.375 5.625.375 12c0 6.422 5.203 11.625 11.625 11.625 6.375 0 11.625-5.203 11.625-11.625C23.625 5.625 18.375.375 12 .375zM10.312 16.5a.57.57 0 00-.562.563v.375c0 .328.234.562.563.562h3.374a.57.57 0 00.563-.563v-.375c0-.28-.281-.562-.563-.562h-.562V9.937c0-.28-.281-.562-.563-.562h-2.25a.57.57 0 00-.562.563v.374c0 .329.234.563.563.563h.562V16.5h-.563zM12 5.25c-.844 0-1.5.703-1.5 1.5 0 .844.656 1.5 1.5 1.5.797 0 1.5-.656 1.5-1.5 0-.797-.703-1.5-1.5-1.5z"}})])
          )
        }
      }
    